import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SundryLabourCheckList } from './Pages';

export const SundryLabourCheckListRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={SundryLabourCheckList} />

    </Fragment>
)